import script from "./AppListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppListView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection});qInstall(script, 'directives', {Ripple});
